import React from 'react'

export default function minimizeSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" viewBox="0 0 24 24"><path d="M4 10h4c1.1 0 2-.9 2-2V4c0-.6-.4-1-1-1S8 3.4 8 4v4H4C3.4 8 3 8.4 3 9S3.4 10 4 10zM16 10h4c.6 0 1-.4 1-1s-.4-1-1-1h-4V4c0-.6-.4-1-1-1s-1 .4-1 1v4C14 9.1 14.9 10 16 10zM15 21c.6 0 1-.4 1-1v-4h4c.6 0 1-.4 1-1s-.4-1-1-1h-4c-1.1 0-2 .9-2 2v4C14 20.6 14.4 21 15 21zM4 16h4v4c0 .6.4 1 1 1s1-.4 1-1v-4c0-1.1-.9-2-2-2H4c-.6 0-1 .4-1 1S3.4 16 4 16z"/></svg>
  )
}
